<template>
  <div class="meiyu">
    <div class="top">
      <div class="topdate">{{date}}</div>
      <span class="title">风险一张图</span>
      <div class="full" @click="buttonfull">
        <svg v-if="watchfull" class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping" />
        </svg>
        <svg v-else class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconquanping" />
        </svg>
      </div>
      <div class="back" @click="back" v-show="backitem">
        <img src="@/assets/meiyu/back.png" alt />
        <span class="backdesc">返回</span>
      </div>
    </div>
    <div class="tabs flexDiv">
      <div class="tabsli" v-for="(item,index) in tabsli" :key="index" @click="tabsliClick(item,index)">
        <div :class="{'activeColor':tabsIndex===index}">{{item}}</div>
        <div class="leftB" :class="{'activeBorder':tabsIndex===index}"></div>
        <div class="rightB" :class="{'activeBorder':tabsIndex===index}"></div>
      </div>
    </div>
    <div v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      id="centermap"
      class="homepage-map">
    </div>
    <div class="left">
      <div class="leftNavs">
        <div class="navTitle">图层控制</div>
        <div class="navMain">
          <div class="navli" v-for="(item,index) in navli" :key="index" v-show="item.isShow">
            <img :src="item.img">
            <div class="navtext">{{item.name}}</div>
            <div>
              <el-switch v-model="item.select" size="mini" @change="(val)=>switchChange(item,val)"></el-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="yjTip" @click="yjTipShow = !yjTipShow">
        <el-badge :value="yjVillage.movingCount + yjVillage.readyForMovingCount">
          <img src="@/assets/riskchart/yj.png">
        </el-badge>
      </div>
      <div class="yjInfo" v-show="yjTipShow">
        <div class="yjTitle">预警信息</div>
        <div class="yjMain">
          <div class="yjList">
            <div>立即转移村落<b style="font-size:16px;color:#e22f32"> {{yjVillage.movingCount}} </b>个</div>
            <div class="clList" v-for="(item,index) in yjVillage.moving" :key="index">
              <span>{{item.townName}}：</span>
              <span>{{item.village}}</span>
            </div>
          </div>
          <div class="yjList">
            <div>准备转移村落<b style="font-size:16px;color:#e22f32"> {{yjVillage.readyForMovingCount}} </b>个</div>
            <div class="clList" v-for="(item,index) in yjVillage.readyForMoving" :key="index">
              <span>{{item.townName}}：</span>
              <span>{{item.village}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="searchDiv">
        <el-cascader size="small" v-model="searchValue" :options="searchList" @change="handleChange" filterable clearable :show-all-levels="false" :props="{label:'adnm' }" placeholder="村落或测站查询"></el-cascader>
      </div>
    </div>
    <div class="right">
      <div class="leftTabs">
        <div class="tabDiv">
          <div class="btn" :class="{'activeBtn':activeBtn==='风险信息'}" @click="tabClick('风险信息')">
            <img src="@/assets/riskchart/fxxx.png">
          </div>
          <div class="tabtext">风险信息</div>
        </div>
        <div class="tabDiv">
          <div class="btn" :class="{'activeBtn':activeBtn==='防御对象'}" @click="tabClick('防御对象')">
            <img src="@/assets/riskchart/fydx.png">
          </div>
          <div class="tabtext">重要村落</div>
        </div>
        <!-- <div class="btn"><img src="@/assets/riskchart/fydx.png"></div> -->
      </div>
      <div class="rightTableDiv" v-show="activeBtn=='风险信息'">
        <div class="contain">
          <div class="title rightTableTop">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">防御对象</span>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt />
            </div>
          </div>
          <!-- 防御对象列表 -->
          <div class="content">
            <el-table
              :data="zyclData"
              :max-height="tableheight"
              stripe
              style="width:100%;"
              show-summary
              sum-text="永嘉县"
              @row-click="clickRow"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="adnm" label="乡镇" align="center"></el-table-column>
              <el-table-column prop="villageCount" label="重要村落(个)" align="center"></el-table-column>
              <!-- <el-table-column prop="houseCount" label="影响户数(户)" align="center"></el-table-column> -->
              <el-table-column prop="population" label="影响人数(人)" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="rightTableDiv borderTable" v-show="activeBtn=='风险信息'">
        <div class="contain">
          <div class="title rightTableTop">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">山洪风险区</span>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt />
            </div>
          </div>
          <div class="content">
            <el-table
              :data="wxqData"
              :max-height="tableheight"
              stripe
              border
              style="width:100%;"
              @row-click="clickRow"
              :row-class-name="tableRowClassName"
              :cell-style="changeCellStyle"
              :header-cell-style="changeHeaderStyle"
              show-summary
              sum-text="永嘉县"
            >
              <el-table-column prop="adnm" label="乡镇" align="center"></el-table-column>
              <!-- <el-table-column prop="eHigh" label="极高风险区" align="center"></el-table-column> -->
              <el-table-column prop="high" label="高风险区" align="center"></el-table-column>
              <el-table-column prop="normal" label="低风险区" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="rightTableDiv1" v-show="activeBtn=='防御对象'">
        <div class="contain">
          <div class="title rightTableTop1">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">重要村落</span>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt />
            </div>
          </div>
          <!-- 防御对象列表 -->
          <div class="content">
            <el-table
              :data="fydxData"
              :max-height="tableheight"
              stripe
              style="width:100%;"
              @row-click="clickRow1"
              :row-class-name="tableRowClassName"
            >
              <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
              <el-table-column prop="adnm" label="重要村落" align="center"></el-table-column>
              <el-table-column prop="type" label="隐患类型" align="center" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="townName" label="乡镇" align="center"></el-table-column>
              <el-table-column prop="villageName" label="行政村" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="radioBtn" :class="{'radioOpen':showRadioDiv}" @mouseover="showRadioDiv = true" @mouseout="showRadioDiv = false">
      <i class="el-icon-coin" v-show="!showRadioDiv"></i>
      <div class="navMain" v-show="showRadioDiv">
        <el-radio-group v-model="mapType" @change="radioChange">
          <el-radio :label="3">水利影像图</el-radio>
          <el-radio :label="1">水利交通图</el-radio>
          <el-radio :label="5">水利地形图</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="markerPopup" ref="markerPopup" v-show="markerPopup">
      <div class="popupTop">{{wxqPointData[pointIndex].adnm}}</div>
      <div class="popupnav">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="1"  v-if="wxqPointData[pointIndex].lng">
            <div class="jbxxInfo">
              <div class="jbxxText"><div>所属乡镇：</div><div>{{wxqPointData[pointIndex].townName}}</div></div>
              <div class="jbxxText"><div>所属行政村：</div><div>{{wxqPointData[pointIndex].villageName}}</div></div>
              <div class="jbxxText"><div>风险等级：</div><div v-if="wxqPointData[pointIndex].danger">{{wxqPointData[pointIndex].danger.dangerLevelName?wxqPointData[pointIndex].danger.dangerLevelName:'/'}}</div></div>
              <div class="jbxxText"><div></div><div></div></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="风险区" name="2" v-if="navli[4].select">
            <div class="wxqInfo" v-if="wxqPointData[pointIndex].danger">
              <el-table :data="wxqPointData[pointIndex].danger.riskList" style="width: 100%" :height="popupTableH">
                <el-table-column prop="name" label="#" align="center">
                </el-table-column>
                <el-table-column prop="population" label="人口" align="center">
                </el-table-column>
                <!-- <el-table-column prop="house" label="房屋" align="center">
                </el-table-column> -->
                <el-table-column prop="person" label="责任人" align="center">
                </el-table-column>
                <el-table-column prop="phone" label="联系方式" align="center">
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="现场图片" name="3" v-if="false">
            <div class="xctpInfo">
              <el-carousel height="180px" indicator-position="outside" v-if="wxqPointData[pointIndex].pic.picUrl.length>0">
                <el-carousel-item v-for="(item,index) in wxqPointData[pointIndex].pic.picUrl" :key="index">
                  <img class="xctpimg" :src="item" @click="onPreview">
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <div class="stMarkerPopup" ref="stMarkerPopup" v-show="stMarkerPopup">
      <div class="popupTop">{{stPointData[stpointIndex].poolName}}</div>
      <div class="popupnav">
        <el-tabs v-model="stActiveName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="1">
            <div class="stInfo">
              <div class="stText"><div>山塘类别：</div><div>{{stPointData[stpointIndex].type}}</div></div>
              <div class="stText"><div>所在位置：</div><div>{{stPointData[stpointIndex].adcdName}}</div></div>
              <div class="stText"><div>是否整治：</div><div>{{stPointData[stpointIndex].isManaging?'是':'否'}}</div></div>
              <div class="stText"><div>整治时间：</div><div>{{stPointData[stpointIndex].managedTime?stPointData[stpointIndex].managedTime:'/'}}</div></div>
              <div class="stText"><div>坝型：</div><div>{{stPointData[stpointIndex].damType}}</div></div>
              <div class="stText"><div>坝顶高程(m)：</div><div>{{stPointData[stpointIndex].damHeight}}</div></div>
              <div class="stText"><div>坝顶宽度(m)：</div><div>{{stPointData[stpointIndex].maxWidth}}</div></div>
              <div class="stText"><div>坝顶长度(m)：</div><div>{{stPointData[stpointIndex].maxLength}}</div></div>
              <div class="stText"><div>集雨面积(km²)：</div><div>{{stPointData[stpointIndex].rainArea}}</div></div>
              <div class="stText"><div>正常蓄水位(m)：</div><div>{{stPointData[stpointIndex].water}}</div></div>
              <div class="stText"><div>正常容积(万m³)：</div><div>{{stPointData[stpointIndex].storage}}</div></div>
              <div class="stText"><div>设计频率(%)：</div><div>{{stPointData[stpointIndex].designedFreq}}</div></div>
              <div class="stText"><div>设计洪水位(m)：</div><div>{{stPointData[stpointIndex].designedWater}}</div></div>
              <div class="stText"><div>设计容积(万m³)：</div><div>{{stPointData[stpointIndex].designedStorage}}</div></div>
              <div class="stText"><div>校核频率(%)：</div><div>{{stPointData[stpointIndex].checkFreq}}</div></div>
              <div class="stText"><div>校核洪水位(m)：</div><div>{{stPointData[stpointIndex].checkWater}}</div></div>
              <div class="stText"><div>校核容积(万m³)：</div><div>{{stPointData[stpointIndex].checkStorage}}</div></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="dialogVisible" width="60%">
      <div class="datebtn">
        <el-button @click="changedate(-1)" size="small">前一天</el-button>
        <span class="demonstration"></span>
        <el-date-picker
          v-model="datev"
          type="date"
          placeholder="选择日期"
          size="small"
          @change="changedate(0)">
        </el-date-picker>
        <el-button @click="changedate(1)" size="small">后一天</el-button>
      </div>
      <div id="station"></div>
    </el-dialog> -->
    <stationDialog ref="stationDialog"></stationDialog>
    <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="wxqPointData[pointIndex].pic.picUrl" />
  </div>
</template>
<script>
// import config from '@/config'
import * as L from 'leaflet'
import screenfull from 'screenfull'
import riskchartTypes from '@/store/types/riskchart'
import stationDialog from '@/components/stationDialog'
import { setMapMarkerItem6, selectMapLayer, selectMapLayer1 } from '@/utils/map'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import request from '@/utils/request'
// leaflet 聚合插件
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
require('@/extend/leaflet-extend.js')
require('@/assets/map/leaflet.ChineseTmsProviders.js')
export default {
  components: { ElImageViewer, stationDialog },
  name: 'riskchart',
  data () {
    return {
      backitem: true,
      watchfull: '',
      isFullscreen: false,
      loading: true,
      date: '',
      height: document.documentElement.clientHeight + 'px',
      tableheight: 350,
      tabsli: ['雨情监测', '水情监测', '风险一张图'],
      tabsIndex: 2,
      selectedTime: [
        {
          name: '当日',
          value: '24h'
        },
        {
          name: '前3小时',
          value: '3h'
        },
        {
          name: '前1小时',
          value: '1h'
        }
      ],
      selectedReservoirRiver: [
        {
          name: '水库',
          value: 'reservoir'
        },
        {
          name: '河道',
          value: 'river'
        }
      ],
      map: '',
      dialogVisible: false,
      beginTime: '',
      endTime: '',
      navli: [
        { id: 1, name: '现场图片', img: require('@/assets/riskchart/xctp.png'), select: true, isShow: false },
        { id: 2, name: '雨量站', img: require('@/assets/riskchart/ylz.png'), select: false, isShow: true },
        { id: 3, name: '河道站', img: require('@/assets/riskchart/swz.png'), select: false, isShow: true },
        { id: 4, name: '重要村落', img: require('@/assets/riskchart/zycl.png'), select: true, isShow: true },
        { id: 5, name: '风险区', img: require('@/assets/riskchart/wxq.png'), select: false, isShow: true },
        { id: 6, name: '山塘', img: require('@/assets/riskchart/st.png'), select: false, isShow: true },
        { id: 7, name: '水库站', img: require('@/assets/riskchart/sk.png'), select: false, isShow: true }
        // { id: 7, name: '水系', img: require('@/assets/riskchart/sx.png'), select: true }
      ],
      activeName: '1',
      stActiveName: '1',
      markerPopup: false,
      stMarkerPopup: false,
      activeBtn: '风险信息',
      yjTipShow: false,
      yjVillage: { moving: [], readyForMoving: [] },
      wxqPointData: [{ pic: { picUrl: [] }, danger: {} }],
      stPointData: [{}],
      wxqData: [],
      zyclData: [],
      fydxData: [],
      czData: [],
      pointIndex: 0, // 当前锚点index
      czpointIndex: 0, // 当前测站锚点index
      stpointIndex: 0, // 当前测站锚点index
      ylzMarkers: null, // 雨量站
      hdzMarkers: null, // 河道站
      skzMarkers: null, // 水库站
      wxqMarkers: null, // 风险区
      zyclMarkers: null, // 重要村落
      xctpMarkers: null, // 现场图片
      stMarkers: null, // 山塘
      ljzyMarkers: null, // 立即转移
      zbzyMarkers: null, // 准备转移
      sxMarkers: null, // 水系
      mapJson: null,
      datev: '',
      stid: '',
      searchValue: [],
      searchList: [{
        value: 0,
        adnm: '村落',
        children: []
      }],
      popupTableH: 180,
      showViewer: false,
      showRadioDiv: false,
      mapType: 3,
      mapObj: {}
    }
  },
  methods: {
    radioChange () {
      if (this.mapObj.tileLayer) {
        this.map.removeLayer(this.mapObj.tileLayer)
      }
      if (this.mapObj.textLayer) {
        this.map.removeLayer(this.mapObj.textLayer)
      }
      this.leaflet(this.mapType, true)
    },
    tabsliClick (item, index) {
      if (item !== '风险一张图') {
        this.$router.push({
          name: 'yjxbasin',
          params: {
            tabsIndex: index
          }
        })
      }
    },
    //  行选中
    clickRow (row) {
      let leafs = document.getElementsByClassName('leaflet-interactive')
      for (let i = leafs.length - 1; i >= 0; i--) {
        const el = leafs[i]
        if (el.getAttribute('stroke') === '#2bd4f2') {
          el.remove()
        }
      }
      // GeoJson数据
      this.drawTownJson(row.adnm)
      if (this.navli[4].select) {
        this.switchChange({ name: '风险区' }, true)
      }
    },
    drawTownJson (name) {
      var myStyle = {
        color: '#2bd4f2',
        weight: 3,
        opacity: 1
      }
      request.get('https://' + window.location.host + '/yjjson/townjson/' + name + '.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle,
          zIndex: -1
        }).addTo(this.map)
      })
      // this.map.flyTo([row.lat, row.lng], 13, {
      //   animate: false,
      //   duration: 0
      // })
    },
    clickRow1 (row, column) {
      if (row.stid) { // 测站
        selectMapLayer1(this, row, this.map)
      } else {
        let openPop = false
        if (column && column.label === '村落名称') {
          openPop = true
        }
        for (let i = 0; i < this.fydxData.length; i++) {
          const el = this.fydxData[i]
          if (el.adcd === row.adcd) {
            selectMapLayer(this, row, this.map, i, openPop, 13)
            break
          }
        }
      }
    },
    handleClick () {},
    onPreview () {
      this.showViewer = true
    },
    // 关闭查看器
    closeViewer () {
      this.showViewer = false
    },
    tabClick (flag) {
      this.activeBtn = flag
      this.$nextTick(() => {
        let rightTableDiv = 0
        let rightTableTop = 0
        if (flag === '风险信息') {
          rightTableDiv = document.getElementsByClassName('rightTableDiv')
          rightTableTop = document.getElementsByClassName('rightTableTop')
        } else {
          rightTableDiv = document.getElementsByClassName('rightTableDiv1')
          rightTableTop = document.getElementsByClassName('rightTableTop1')
          if (!this.navli[3].select) { // 重要村落，未选中
            this.navli[3].select = true
            this.getPreventionDataInfo(1)
          }
        }
        this.tableheight = rightTableDiv[0].offsetHeight - rightTableTop[0].offsetHeight - 30
      })
    },
    switchChange (item, val) {
      switch (item.name) {
        case '雨量站':
          if (val === true) {
            this.getRelationInfo(['PP'], '雨量站')
          } else {
            this.getRelationInfo([], '雨量站')
          }
          break
        case '河道站':
          if (val === true) {
            this.getRelationInfo(['ZZ'], '河道站')
          } else {
            this.getRelationInfo([], '河道站')
          }
          break
        case '水库站':
          if (this.skzMarkers) {
            this.skzMarkers.clearLayers()
            this.skzMarkers = null
          }
          if (val === true) {
            this.getRelationInfo(['RR'], '水库站')
          } else {
            this.getRelationInfo([], '水库站')
          }
          break
        case '风险区':
          if (this.wxqMarkers) {
            this.wxqMarkers.clearLayers()
            this.wxqMarkers = null
          }
          if (val === true) {
            this.getPreventionDataInfo(2)
          }
          break
        case '重要村落':
          if (this.zyclMarkers) {
            this.zyclMarkers.clearLayers()
            this.zyclMarkers = null
          }
          if (val === true) {
            this.getPreventionDataInfo(1)
          }
          break
        case '山塘':
          if (this.stMarkers) {
            this.stMarkers.clearLayers()
            this.stMarkers = null
          }
          if (val === true) {
            this.getPreventionDataInfopool()
          }
          break
        // case '水系':
        //   if (val === true) {
        //     this.sxMarkers.setUrl(config.ApiYJ + '/files/layers/')
        //   } else {
        //     this.sxMarkers.setUrl('')
        //   }
        //   break
        default:
          break
      }
    },
    handleChange (val) {
      this.searchList.forEach((item, index) => {
        if (item.value === val[0]) {
          this.clickRow1(item.children[val[1]], { label: '村落名称' })
        }
      })
    },
    changedate (num) {
      let odate = new Date()
      let hh = odate.getHours()
      let mm = odate.getMinutes()
      let nowdate = new Date(this.datev)
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      nowdate.setTime(nowdate.getTime() + num * 24 * 60 * 60 * 1000)
      year = nowdate.getFullYear()
      mon = nowdate.getMonth() + 1
      dd = nowdate.getDate()
      this.datev = year + '-' + mon + '-' + dd
      this.endTime = this.datev + ' ' + hh + ':' + mm
      // 开始时间前一天
      nowdate.setTime(nowdate.getTime() - 24 * 60 * 60 * 1000)
      year = nowdate.getFullYear()
      mon = nowdate.getMonth() + 1
      dd = nowdate.getDate()
      this.beginTime = year + '-' + mon + '-' + dd + ' ' + hh + ':' + mm
      this.getRainWaterTotal()
    },
    buttonfull () {
      if (!screenfull.enabled) {
        return false
      } else {
        screenfull.toggle()
      }
    },
    back () {
      this.isFullscreen = true
      this.$nextTick(() => {
        this.$router.push('/nav/Homepage')
      })
    },
    // table 行样式
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0 && row.overflowGuaranteeWater <= 0) {
        // 超警戒未超保证
        return 'warning-row'
      } else if (row.overflowGuaranteeWater > 0) {
        return 'success-row'
      }
      return ''
    },
    // table 表头样式
    changeHeaderStyle (row, column, rowIndex, columnIndex) {
      if (row.column.label.includes('极高风险区')) {
        return 'background-color: #671529' // 修改的样式
      } else if (row.column.label.includes('高风险区')) {
        return 'background-color: #6c4617' // 修改的样式
      } else if (row.column.label.includes('低风险区')) {
        return 'background-color: #5a5d19' // 修改的样式
      } else {
        return ''
      }
    },
    // table 列样式
    changeCellStyle (row, column, rowIndex, columnIndex) {
      if (row.column.label.includes('极高风险区')) {
        if (row.rowIndex % 2 === 0) {
          return 'background-color: #6a273c' // 修改的样式
        } else {
          return 'background-color: #671529' // 修改的样式
        }
      } else if (row.column.label.includes('高风险区')) {
        if (row.rowIndex % 2 === 0) {
          return 'background-color: #705628' // 修改的样式
        } else {
          return 'background-color: #6c4617' // 修改的样式
        }
      } else if (row.column.label.includes('低风险区')) {
        if (row.rowIndex % 2 === 0) {
          return 'background-color: #5e702e' // 修改的样式
        } else {
          return 'background-color: #5a5d19' // 修改的样式
        }
      } else {
        return ''
      }
    },
    getnowtime () {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date =
        year +
        '年' +
        this.conver(month) +
        '月' +
        this.conver(date) +
        '日' +
        ' ' +
        weekend +
        ' ' +
        this.conver(hours) +
        ':' +
        this.conver(minutes) +
        ':' +
        this.conver(seconds)
    },
    conver (s) {
      return s < 10 ? '0' + s : s
    },
    leaflet (mapType, reload) {
      let map = ''
      this.mapObj = L.CreateTianDiTuMap('centermap', {
        mapType: mapType,
        crs: L.CRS.EPSG4490,
        zoomControl: false,
        minZoom: 10, // 最小缩放等级
        maxZoom: 18
      }, reload, this.map, true)
      map = this.mapObj.map.setView([28.34, 120.77], 11)
      if (!reload) {
        // this.sxMarkers = L.tileLayer.CustomArcGISServerLayer(
        //   // config.ApiYJ + '/files/layers/' // 地图服务地址
        // ).addTo(map)
        var myStyle = {
          color: '#2dd9f8',
          weight: 3,
          opacity: 1
        }
        request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then(res => {
          L.geoJSON(res.data, {
            style: myStyle
          }).addTo(map)
          this.drawBoundary(res.data.features[0].geometry.coordinates[0], map)
        })
        this.map = map
      } else {
        // this.sxMarkers.bringToFront()
        this.map = map
      }
    },
    drawBoundary (blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach((item) => {
          points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        pArray.push(pArray[0])
      }
      // 添加遮蔽层
      var plyall = L.polygon(pArray, {
        color: 'transparent',
        fillColor: '#242422',
        fillOpacity: 0.8
      }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    // 村落预警信息
    async getWarnVillageByTown (data) {
      let result = await this.$store.dispatch(riskchartTypes.getWarnVillageByTown, {})
      this.yjVillage = result.detail
      this.drawVillagePoint(result.detail.readyForMovingVillage, '准备转移')
      this.drawVillagePoint(result.detail.movingVillage, '立即转移')
    },
    gettime: function () {
      let nowdate = new Date()
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      this.datev = year + '-' + mon + '-' + dd
      this.endTime = year + '-' + mon + '-' + dd + ' ' + hh + ':' + mm
      // 开始时间前一天
      nowdate.setTime(nowdate.getTime() - 24 * 60 * 60 * 1000)
      year = nowdate.getFullYear()
      mon = nowdate.getMonth() + 1
      dd = nowdate.getDate()
      this.beginTime = year + '-' + mon + '-' + dd + ' ' + hh + ':' + mm
    },
    // 获取测站信息
    async getRelationInfo (STTPs, name) {
      let result = {}
      for (let i = 0; i < STTPs.length; i++) {
        const el = STTPs[i]
        result = await this.$store.dispatch(riskchartTypes.GET_relation_info, {
          STTP: el
        })
      }
      let data = result || []
      if (name === '雨量站') {
        if (this.ylzMarkers) {
          this.ylzMarkers.clearLayers()
          this.ylzMarkers = null
        }
        this.getListofSearch(1, name, data)
      } else if (name === '河道站') {
        if (this.hdzMarkers) {
          this.hdzMarkers.clearLayers()
          this.hdzMarkers = null
        }
        this.getListofSearch(2, name, data)
      } else {
        if (this.skzMarkers) {
          this.skzMarkers.clearLayers()
          this.skzMarkers = null
        }
        this.getListofSearch(6, name, data)
      }
      this.czData = data
      this.drawczPoint(data, STTPs[0], name)
    },
    // 获取重要村落,风险区,现场图片信息
    async getPreventionDataInfo (flag) {
      this.loading = true
      this.fydxData = []
      let result = await this.$store.dispatch(riskchartTypes.getPreventionDataInfo, {})
      let wxq = []
      for (let i = 0; i < result.rows.length; i++) {
        const el = result.rows[i]
        if (el.lng) {
          this.fydxData.push(el)
        }
        if (el.danger) {
          wxq.push(el.danger)
          result.rows[i].adnm = result.rows[i].adnm ? result.rows[i].adnm : el.danger.adcdnm
        } else {
          wxq.push({})
        }
      }
      if (flag === 1) {
        this.drawylPoint(result.rows, '重要村落')
      } else if (flag === 2) {
        this.drawwxqPoint(wxq, '风险区')
      } else {
        this.drawylPoint(result.rows, '重要村落')
        // this.drawwxqPoint(wxq, '风险区')
      }
      this.fydxData.forEach((item, key) => {
        this.fydxData[key].value = key
      })
      this.searchList[0].children = this.fydxData
      if (result.rows.length > 0) {
        this.wxqPointData = result.rows
      }
      this.loading = false
    },
    // 获取山塘信息
    async getPreventionDataInfopool () {
      this.loading = true
      let result = await this.$store.dispatch(riskchartTypes.getPreventionDataInfopool, {})
      this.drawstPoint(result.rows, '山塘信息')
      if (result.rows.length > 0) {
        this.stPointData = result.rows
      }
      this.loading = false
    },

    // 乡镇风险区表格list
    async getDangerAreaInfotown () {
      this.loading = true
      let result = await this.$store.dispatch(riskchartTypes.getDangerAreaInfotown, {})
      this.wxqData = result.rows
      this.loading = true
    },
    // 重要村落表格list
    async getPreventionDataInfotown () {
      this.loading = true
      let result = await this.$store.dispatch(riskchartTypes.getPreventionDataInfotown, {})
      this.zyclData = result.rows
      this.loading = true
    },
    // 水雨情
    async getRainWaterTotal () {
      let result = await this.$store.dispatch(riskchartTypes.getRainWaterTotal, {
        STID: this.stid,
        BeginTime: this.beginTime,
        EndTime: this.endTime
      })
      this.dialogVisible = true
      this.$nextTick(() => {
        this.drawChart(result.waterValues, result.rainValues, result.wrZs, result.tMs)
      })
    },
    // 下拉框数据筛选
    getListofSearch (index, name, data) {
      data.forEach((item, key) => {
        data[key].adnm = item.stnm
        data[key].value = key
        data[key].lat = item.lttd
        data[key].lng = item.lgtd
      })
      if (this.navli[index].select) {
        this.searchList.push({
          value: index,
          adnm: name,
          children: data
        })
      } else {
        for (let i = this.searchList.length - 1; i >= 0; i--) {
          if (this.searchList[i].adnm === name) {
            this.searchList.splice(i, 1)
          }
        }
      }
    },
    // 地图上添加标记点
    drawylPoint (arr, type) {
      let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (item.lat) {
          if (type === '重要村落') {
            myIcon = L.icon({
              iconUrl: require('@/assets/riskchart/zycl.png'),
              iconAnchor: [8, 8]
            })
          }
          let markers = L.marker([item.lat, item.lng], {
            icon: myIcon
            // title: item.adcdName
          })
          markers.bindPopup('<div class="marker_popup" id="marker_popup' + index + '"></div>')
          markers.metadata = { adcd: item.adcd, lng: item.lng, lat: item.lat, index: index }
          markers.on('click', (e) => {
            let riverStationPopup = this.$refs['markerPopup']
            let rainfallPopupCcontent = document.getElementById('marker_popup' + index)
            this.markerPopup = true
            this.pointIndex = index
            if (item.adnm) {
              this.activeName = '1'
            } else {
              this.activeName = '2'
            }
            rainfallPopupCcontent.appendChild(riverStationPopup)
            this.$nextTick(() => {
              let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
              pop.style.left = '-205px'
              let tabsDom = document.getElementsByClassName('el-tabs__header')[0]
              let popupTopDom = document.getElementsByClassName('popupTop')[0]
              this.popupTableH = riverStationPopup.offsetHeight - tabsDom.offsetHeight - popupTopDom.offsetHeight - 20
            })
          })
          markers.bindTooltip('<b>' + item.adnm + '</b>', {
            parmanent: true,
            sticky: true,
            className: 'anim-tooltip'
          })
          layers.push(markers)
        }
      })
      if (type === '重要村落') {
        this.zyclMarkers = L.layerGroup(layers)
        this.map.addLayer(this.zyclMarkers)
      }
    },
    // 地图上添加标记点
    drawstPoint (arr, type) {
      let myIcon
      let layers = L.markerClusterGroup()
      arr.forEach((item, index) => {
        if (item.lat) {
          if (type === '山塘信息') {
            myIcon = L.icon({
              iconUrl: require('@/assets/riskchart/st.png'),
              iconAnchor: [8, 8]
            })
          }
          let markers = L.marker([item.lat, item.lng], {
            icon: myIcon
            // title: item.poolName
          })
          markers.bindPopup('<div class="marker_popup" id="stmarker_popup' + index + '"></div>')
          markers.on('click', (e) => {
            let riverStationPopup = this.$refs['stMarkerPopup']
            let rainfallPopupCcontent = document.getElementById('stmarker_popup' + index)
            this.stMarkerPopup = true
            this.stpointIndex = index
            rainfallPopupCcontent.appendChild(riverStationPopup)
            this.$nextTick(() => {
              let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
              pop.style.left = '-205px'
            })
            // this.$nextTick(() => {
            //   let pop = document.getElementsByClassName('leaflet-popup')
            //   pop[0].style.left = '-260px'
            //   if (pop[1]) {
            //     pop[1].style.left = '-260px'
            //   }
            // })
          })
          markers.bindTooltip('<b>' + item.poolName + '</b>', {
            parmanent: true,
            sticky: true,
            className: 'anim-tooltip'
          })
          layers.addLayer(markers)
        }
      })
      if (type === '山塘信息') {
        this.stMarkers = layers
        this.map.addLayer(this.stMarkers)
      }
    },
    // 绘制风险区面
    drawwxqPoint (arr, type) {
      // let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (item.giszb && item.giszb.length > 0) {
          let style = '#F3F34D'
          for (let i = 0; i < item.giszb.length; i++) {
            let markers = setMapMarkerItem6(this, '<b>' + item.adcdnm + '</b>', 13, item, i, style, this.map, false, false, null)
            markers.bindPopup('<div class="marker_popup" id="wxqmarker_popup' + index + 'i' + i + '"></div>')
            markers.on('click', (e) => {
              let riverStationPopup = this.$refs['markerPopup']
              let rainfallPopupCcontent = document.getElementById('wxqmarker_popup' + index + 'i' + i)
              this.markerPopup = true
              this.pointIndex = index
              if (item.adnm) {
                this.activeName = '1'
              } else {
                this.activeName = '2'
              }
              rainfallPopupCcontent.appendChild(riverStationPopup)
              this.$nextTick(() => {
                let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
                pop.style.left = '-205px'
              })
            })
            layers.push(markers)
          }
        }
      })
      if (type === '风险区') {
        this.wxqMarkers = L.layerGroup(layers)
        this.map.addLayer(this.wxqMarkers)
      }
    },
    // 地图上添加测站标记
    drawczPoint (arr, type, name) {
      let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (type === 'PP') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/ylz.png'),
            iconAnchor: [8, 8]
          })
        } else if (type === 'ZZ') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/swz.png'),
            iconAnchor: [8, 8]
          })
        } else {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/sk.png'),
            iconAnchor: [8, 8]
          })
        }
        let markers = L.marker([item.lttd, item.lgtd], {
          icon: myIcon
        })
        markers.metadata = item
        markers.on('click', (e) => {
          this.stid = item.stid
          this.$refs.stationDialog.showlog(item)
        })
        markers.bindTooltip('<b>' + item.stnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
        layers.push(markers)
      })
      if (name === '雨量站') {
        this.ylzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.ylzMarkers)
      } else if (name === '河道站') {
        this.hdzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.hdzMarkers)
      } else {
        this.skzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.skzMarkers)
      }
    },
    // 地图上添加转移村庄标记
    drawVillagePoint (arr, name) {
      let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (name === '准备转移') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/zbzy.gif'),
            iconAnchor: [8, 8]
          })
        } else if (name === '立即转移') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/ljzy.gif'),
            iconAnchor: [8, 8]
          })
        }
        let markers = L.marker([item.lat, item.lng], {
          icon: myIcon
          // title: item.adnm
        })
        // markers.on('click', (e) => {
        // this.stid = item.stid
        // this.getRainWaterTotal()
        // })
        markers.bindTooltip('<b>' + item.adnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
        layers.push(markers)
      })
      if (name === '准备转移') {
        this.zbzyMarkers = L.layerGroup(layers)
        this.map.addLayer(this.zbzyMarkers)
      } else {
        this.ljzyMarkers = L.layerGroup(layers)
        this.map.addLayer(this.ljzyMarkers)
      }
    },
    drawChart (chartwaterValues, chartrainValues, chartwrZs, chartxline) {
      let myChart = this.$echarts.init(document.getElementById('station'))
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['雨量', '水位', '警戒水位'],
          orient: 'vertical',
          x: 'left',
          y: 'center',
          padding: [0, 30, 0, 0],
          itemWidth: 10
        },
        grid: {
          top: '10%',
          left: '10%',
          right: '4%',
          bottom: '15%'
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: false,
            data: chartxline,
            axisLabel: {
              interval: 0,
              formatter: function (params) {
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 6
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < provideNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水位',
            min: this.startWaterMark,
            scale: true,
            interval: 100,
            axisLabel: {
              formatter: '{value} m'
            }
          },
          {
            type: 'value',
            name: '雨量',
            max: function (value) {
              return Math.round(value.max * 1.5)
            },
            nameLocation: 'start',
            inverse: true, // 翻转
            interval: 30,
            axisLabel: {
              formatter: '{value} mm'
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#33C9DE'
            },
            data: chartrainValues
          },
          {
            name: '水位',
            type: 'line',
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: {
              borderWidth: 2,
              color: '#15d186'
            },
            lineStyle: {
              width: 3
            },
            data: chartwaterValues
          },
          {
            name: '警戒水位',
            type: 'line',
            symbol: 'none',
            itemStyle: {
              color: '#f4e74c'
            },
            lineStyle: {
              width: 3
            },
            data: chartwrZs
          }
        ]
      })
    }
  },
  created () {
    // this.$nextTick(() => {
    //   this.checkItem(this.selectedTime[2], 2)
    // })
  },
  mounted () {
    this.gettime()
    this.getPreventionDataInfo()
    this.getDangerAreaInfotown()
    this.getPreventionDataInfotown()
    this.getWarnVillageByTown()
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
      if (this.watchfull) {
        this.backitem = false
      } else {
        this.backitem = true
      }
    }
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.$nextTick(() => {
      this.leaflet(3)
    })
    this.getnowtime()
    this.loading = false
    this.$nextTick(() => {
      let right = document.getElementsByClassName('right')[0]
      if (window.innerWidth >= 1800) {
        right.style.width = '460px'
      }
      let rightTableDiv = document.getElementsByClassName('rightTableDiv')
      let rightTableTop = document.getElementsByClassName('rightTableTop')
      this.tableheight = rightTableDiv[0].offsetHeight - rightTableTop[0].offsetHeight - 30
      let sumTable = document.getElementsByClassName('el-table__footer-wrapper')
      for (let i = 0; i < sumTable.length; i++) {
        const el = sumTable[i]
        el.onclick = function () {
          let leafs = document.getElementsByClassName('leaflet-interactive')
          for (let i = leafs.length - 1; i >= 0; i--) {
            const el = leafs[i]
            if (el.getAttribute('stroke') === '#2bd4f2') {
              el.remove()
            }
          }
          _this.map.flyTo([28.34, 120.77], 11, {
            animate: false,
            duration: 0
          })
        }
      }
    })
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style>
.select-option {
  z-index: 9999 !important;
  border: 1px solid #00f0ff;
  background-color: #060a22;
}
.select-option .el-select-dropdown__item {
  background-color: #060a22;
  color: #ffffff;
}
.select-option .el-select-dropdown__item.hover,
.select-option .el-select-dropdown__item:hover {
  background-color: #10173e;
}
</style>

<style lang="less" scoped>
@import url("../../assets/map/leaflet.css");
.centerMapContent {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap {
  width: 100%;
  height: 100%;
  position: relative;
}
@media screen and (min-height: 1100px) {
  .centerMapContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #centermap {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.tabs{
  width: 680px;
  height: 40px;
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  margin: auto;
  background: rgba(0,0,0,0.1);
  z-index: 500;
  color: #fff;
  font-size: 22px;
  border: 1px solid #0dadf0;
  border-radius: 5px;
  *{
    box-sizing: border-box;
  }
  .tabsli{
    width: 220px;
    margin: 0 10px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    position: relative;
    cursor: pointer;
  }
  .leftB{
    width: 20px;
    height: 32px;
    position: absolute;
    left: 0px;
    top: -1px;
    border-right: 0!important;
  }
  .rightB{
    width: 20px;
    height: 32px;
    position: absolute;
    right: 0px;
    top: -1px;
    border-left: 0!important;
  }
  .activeBorder{
    border: 2px solid #21fffb;
  }
  .activeColor{
    color: #00eaff;
    background: rgba(24,126,228,0.3);
  }
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  /* background:rgba(162,44,25,.6); */
  background-image: url(~@/assets/meiyu/chaojin.png);
  background-repeat: no-repeat;
  background-size: 141px 87px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  /* min-height: 36px; */
  height: 87px;
  /* height: 100%; */
}
#chartall,
#danzhan,
#zhazhan {
  z-index: 9999999 !important;
}
.rainchartAll {
  width: 1000px;
  height: 280px;
  margin: 50px auto 0 auto;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 850px;
  height: 85px;
  left: 50%;
  margin-left: -425px;
  top: 85px;
  z-index: 9999;
}
.warn-name {
  width: 100%;
  height: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 30px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.warn-num > span {
  font-size: 16px;
  color: #fff;
  margin-left: 10px;
}
</style>
<style lang="less" scoped>
.meiyu {
  // background: #21251f;
  height: 100%;
  position: relative;
  overflow: hidden;
  .el-dialog {
    .topthree {
      // display: inline-block;
      height: 70px;
      // justify-content: space-between;
      // display: flex;
      .topitem {
        // margin-top: 25px;
        position: relative;
        display: inline-block;
        color: #fff;
        width: 117px;
        margin-left: 45px;
        margin-top: 25px;
        img {
          width: 117px;
          height: 71px;
        }
        .topdesc {
          font-size: 14px;
          position: absolute;
          top: 11px;
          left: 25px;
          width: 100px;
          left: 50%;
          margin-left: -50px;
          height: 15px;
          text-align: center;
        }
        .val {
          .topdesc;
          top: 35px;
          left: 45px;
          font-size: 24px;
          text-align: center;
          font-style: italic;
          font-weight: 500;
          .danwei {
            font-size: 14px;
            position: absolute;
            top: 10px;
          }
        }
      }
    }
    .title {
      height: 33px;
      position: relative;
      margin-top: -8px;
      .titlename {
        height: 33px;
        position: relative;
        /deep/ .titlename_select {
          position: absolute;
          top: -13px;
          .el-input--suffix {
            .el-input__inner {
              width: 160px;
              background: #060a22;
              border: none;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        .button {
          position: relative;
          display: inline-block;
          padding: 0.5rem 1rem;
          background: transparent;
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font: bold 200%/1 sans-serif;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
            background: #fff;
            transform: skew(45deg);
          }
        }
        .titlename_span {
          font-size: 18px;
          color: #fff;
          position: absolute;
          top: 0;
        }
        .titlename_up {
          width: 100%;
          height: 100%;
          span.ssyq,
          span.sssq {
            width: 35%;
            font-size: 18px;
            display: block;
            float: left;
            color: #fff;
          }
          .selected_time {
            width: 65%;
            height: 100%;
            float: right;
            .time_item {
              cursor: pointer;
              height: 30px;
              float: right;
              padding: 0 7px;
              line-height: 26px;
              display: block;
              font-size: 14px;
              color: #ffffff;
              border: 1px solid #079eb6;
              transform: skewX(-30deg);
              span {
                display: block;
                transform: skewX(30deg);
              }
            }
            .item_active {
              background: #064961;
            }
          }
        }
        img {
          width: 100%;
          height: 7px;
          position: absolute;
          top: 27px;
        }
      }
    }
  }
  .top {
    background-image: url("~@/assets/meiyu/top.png");
    background-repeat: no-repeat;
    background-size: 100% 200%;
    height: 77px;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 999;
    .topdate {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      left: 65px;
    }
    .title {
      margin-top: 23px;
      font-size: 32px;
      color: #00f0ff;
      font-weight: bold;
      display: inline-block;
    }
    .person {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      right: 90px;
      .dbld {
        span {
          color: #fec307;
        }
      }
      .zbry {
        .dbld;
        margin-left: 30px;
      }
    }
    .back {
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 8px;
      width: 70px;
      img {
        width: 26px;
        height: 24px;
      }
      .backdesc {
        color: #00dcfc;
        font-size: 15px;
        line-height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -8px;
        margin-left: 5px;
      }
    }
    .full {
      .back;
      right: 75px;
    }
  }
  .left{
    // width: 430px;
    // height: calc(100% - 100px);
    position: absolute;
    left: 50px;
    top: 75px;
    z-index: 999;
    .leftNavs{
      width: 185px;
      margin-top: 10px;
      font-size: 13px;
      color: #fff;
      background: #0a1821;
      border-radius: 5px;
      .navTitle{
        text-align: center;
        line-height: 40px;
        border-bottom: 1px solid #2e383f;
      }
      .navMain{
        padding-top: 15px;
        .navli{
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px 15px;
          .navtext{
            width: 80px;
          }
        }
      }
    }
    .yjTip{
      position: absolute;
      top: 15px;
      right: -50px;
      cursor: pointer;
    }
    .yjInfo{
      width: 250px;
      position: absolute;
      top: 60px;
      right: -270px;
      font-size: 13px;
      color: #fff;
      background: rgba(15,17,38, 0.9);
      border-radius: 5px;
      .yjTitle{
        line-height: 40px;
        border-bottom: 1px solid #2e383f;
        font-size: 14px;
        padding: 0 25px;
      }
      .yjMain{
        width: 100%;
        padding: 0 25px;
        .yjList{
          line-height: 30px;
          padding: 10px 0;
          &:nth-of-type(1){
            border-bottom: 1px solid #2e383f;
          }
          .clList{
            span{
              &:nth-of-type(2){
                padding-right: 10px;
                color: #00f0ff;
              }
            }
          }
          // .clList{
          //   display: flex;
          //   flex-wrap: wrap;
          //   div{
          //     padding-right: 10px;
          //     color: #00f0ff;
          //   }
          // }
        }
      }
    }
    .searchDiv{
      position: absolute;
      top: 10px;
      right: -250px;
      width: 150px;
    }
  }
  .right {
    width: 500px;
    height: calc(100% - 100px);
    position: absolute;
    // background: #fec307;
    top: 75px;
    bottom: 40px;
    right: 20px;
    z-index: 999;
    .leftTabs{
      position: absolute;
      top: 10px;
      left: -100px;
      .tabDiv{
        width: 78px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .btn{
          width: 78px;
          height: 78px;
          cursor: pointer;
          background: #0d1015;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 10px solid #0d1015;
        }
        .activeBtn{
          width: 78px;
          height: 78px;
          background: #f99201;
          border: 10px solid #596a38;
        }
        .tabtext{
          color:#fff;
          font-size: 15px;
          margin: 12px 0 20px;
        }
      }
    }
    .rightTableDiv,.rightTableDiv1 {
      width: 100%;
      height: calc(50% - 10px);
      margin-top: 10px;
      background: #060a22;
      // box-shadow: 0 0 5px #283955 inset;
      box-shadow: 0 0 12px #253578;
      padding: 15px 15px;
      .contain {
        width: 100%;
        height: 100%;
        // background: #fec307;
        .title {
          height: 33px;
          .titlename {
            height: 33px;
            position: relative;
            /deep/ .titlename_select {
              position: absolute;
              top: -13px;
              .el-input--suffix {
                .el-input__inner {
                  width: 160px;
                  background: #060a22;
                  border: none;
                  color: #ffffff;
                  font-size: 18px;
                }
              }
            }
            .button {
              position: relative;
              display: inline-block;
              padding: 0.5rem 1rem;
              background: transparent;
              color: white;
              text-transform: uppercase;
              text-decoration: none;
              font: bold 200%/1 sans-serif;
              &::before {
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 0;
                background: #fff;
                transform: skew(45deg);
              }
            }
            .titlename_span {
              font-size: 18px;
              color: #fff;
              position: absolute;
              top: 0;
            }
            .titlename_up {
              width: 100%;
              height: 100%;
              span.ssyq,
              span.sssq {
                width: 25%;
                font-size: 18px;
                display: block;
                float: left;
                color: #fff;
              }
              .selected_time {
                width: 75%;
                height: 100%;
                float: right;
                .time_item {
                  cursor: pointer;
                  height: 30px;
                  float: right;
                  padding: 0 7px;
                  line-height: 26px;
                  display: block;
                  font-size: 14px;
                  color: #ffffff;
                  border: 1px solid #079eb6;
                  transform: skewX(-30deg);
                  span {
                    display: block;
                    transform: skewX(30deg);
                  }
                }
                .item_active {
                  background: #064961;
                }
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .content {
          margin-top: 10px;
          position: relative;
          .summary{
            width: 100%;
            position: absolute;
            top: 10px;
            left: 0;
          }
          // width: 430px;
        }
      }
    }
    .rightTableDiv1{
      height: calc(100% - 10px);
    }
  }
  .radioBtn {
    width: 40px;
    height: 40px;
    border: 1px solid #3C6EFB;
    background: rgba(64,158,255,0.8);
    border-radius: 5px;
    cursor: pointer;
    position: absolute;
    top: 400px;
    left: 50px;
    z-index: 501;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: right 1s ease;
    i {
      font-size: 24px;
      color: #fff;
    }
    .navMain {
      padding: 10px 0;
      /deep/ .el-radio-group {
        width: 130px;
      }
      /deep/ .el-radio {
        padding: 15px 0;
        display: block;
        font-size: 18px;
        .el-radio__input.is-checked+.el-radio__label {
          color: #fff933;
        }
        .el-radio__input.is-checked .el-radio__inner {
          background: #fff933;
          border-color: #fff933;
        }
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      /deep/ .el-radio__label {
        padding-left: 15px;
        font-size: 18px;
        color: #fff;
      }
    }
  }
  .radioOpen {
    width: 150px;
    height: auto;
  }
  /deep/ .leaflet-popup{
    // left: -205px!important;
    .leaflet-popup-content{
      margin: 0;
      width: 100%!important;
    }
    .leaflet-popup-content-wrapper{
      background: none;
    }
    .leaflet-popup-tip{
      display: none;
    }
  }
  .markerPopup,.stMarkerPopup{
    width: 406px;
    min-height: 300px;
    font-size: 14px;
    color: #fff;
    background: rgba(23, 31, 53, 1);
    .popupTop{
      height: 50px;
      line-height: 50px;
      padding: 0 25px;
      border-bottom: 1px solid #3d4357;
    }
    .popupnav{
      width: 100%;
      padding: 0 25px;
      display: flex;
      .navtab{
        color: #fff;
        line-height: 30px;
        cursor: pointer;
        margin: 10px 20px 10px 0;
        font-weight: bolder;
        &:nth-of-type(1){
          border-bottom: 2px solid #00ddfe;
        }
      }
      .jbxxInfo ,.jbxxLink{
        width: 100%;
        border-bottom: 1px solid #363d52;
        padding-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
        .jbxxText{
          width: 50%;
          display: flex;
          line-height: 33px;
          div:nth-of-type(1){
            color: #a4a5ab;
          }
          &:nth-of-type(4){
            div:nth-of-type(1){
              text-indent: 2em;
            }
          }
        }
      }
      .jbxxLink{
        padding: 10px 0;
        border-bottom: 0;
        .jbxxText{
          width: 100%;
        }
      }
      .wxqInfo,.stInfo{
        width: 100%;
        padding-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
        .wxqText{
          width: 100%;
          background: #1d2e4a;
          height: 40px;
          line-height: 20px;
          margin-bottom: 10px;
          .title{
            background: #223c5f;
            width: 100px;
            line-height: 40px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          .info{
            width: calc(100% - 100px);
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            div{
              width: 50%;
            }
          }
        }
        .stText{
          // width: 50%;
          display: flex;
          line-height: 20px;
          padding: 6px 0;
          div:nth-of-type(1){
            color: #a4a5ab;
          }
        }
      }
      .xctpInfo{
        width: 100%;
        padding-bottom: 10px;
        .xctpimg{
          width: 100%;
          height: 180px;
        }
      }
      /deep/ .el-tabs{
        width: 100%;
      }
      /deep/ .el-tabs__nav-wrap::after{
        background: none;
      }
      /deep/ .el-tabs__item.is-active{
        color: #00ddfe;
      }
      /deep/ .el-tabs__active-bar{
        background-color: #00ddfe;
      }
      /deep/ .el-tabs__item{
        color: #fff;
      }
    }
  }
  .markerPopup{
    .popupnav{
      .stInfo{
        .stText{
          width: 50%;
          div:nth-of-type(1){
            color: #a4a5ab;
          }
          &:nth-of-type(5),&:nth-of-type(6){
            div:nth-of-type(1){
              text-indent: 2em;
            }
          }
          &:nth-of-type(3),&:nth-of-type(4){
            div:nth-of-type(1){
              text-indent: 1em;
            }
          }
        }
      }
    }
  }
  .stMarkerPopup{
    width: 600px;
    .popupnav{
      .stInfo{
        .stText{
          width: 33%;
          div:nth-of-type(1){
            color: #a4a5ab;
          }
          &:nth-of-type(2){
            width: 66%;
          }
        }
      }
    }
  }
  .datebtn{
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #station{
    width: 100%;
    height: calc(100% - 50px);
  }
}
.meiyu /deep/ .el-dialog {
  z-index: 9999999!important;
  // background-color: #fff;
  background-color: rgba(255,255,255,1);
  margin-top: 22vh !important;
  // width: 47%;
  // height: 50%
  .el-dialog__body {
    padding-top: 10px;
    overflow: auto;
    height: 400px;
  }
  .el-dialog__title {
    color: #fff;
  }
  // .el-dialog__close {
  //   color: #fff;
  // }
}

.flexDiv {
    /* 横向排列 */
    display: flex;
    align-items: center;
}

.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}
.el-dialog {
  background-color: #060a22;
  .gateitem {
    margin-top: 17px;
    width: 100%;
    // height: 100px;
    border: 1px solid #1a3a6c;
    .gatetop {
      height: 35px;
      line-height: 35px;
      background: #0f3164;
      .name {
        font-size: 15px;
        color: #fff;
        float: left;
        margin-left: 17px;
      }
      .time {
        color: #fff;
        font-size: 14px;
        float: right;
        margin-right: 10px;
      }
      .desc {
        font-size: 14px;
        color: #00deff;
        float: right;
        margin-right: 17px;
      }
    }
    .gateicons {
      margin-top: 6px;
      .gateicon {
        margin-left: 17px;
        height: 55px;
        position: relative;
        margin-top: 5px;
        // margin-bottom: 5px;
        text-align: center;
        width: 22px;
        height: 38px;
        img {
          width: 22px;
          height: 38px;
        }
        span {
          color: #fff;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
}
.meiyu /deep/.el-image-viewer__close{
  color:#fff
}
.meiyu /deep/ .el-table {
  overflow:visible !important;
}
.meiyu /deep/ .el-table tr {
  // text-align: center;
  color: #fff;
  background: #060a22;
}
.meiyu /deep/ .el-table tr.el-table__row--striped td {
  background: #061737;
}
.meiyu /deep/ .content .el-table .warning-row td {
  background: #b7b71f !important;
}
.meiyu /deep/ .content .el-table .success-row {
  background: #dc3217;
}
.meiyu /deep/ .el-table td {
  padding: 8px 0;
  border: none;
}
.meiyu /deep/ .el-table th.is-leaf {
  border: none;
}
.borderTable /deep/ .el-table td {
  // text-align: center;
  // padding: 8px 0;
  border: 1px solid #072447;
  border-bottom: none;
}
.borderTable /deep/ .el-table th.is-leaf {
  border: 1px solid #072447;
  border-bottom: none;
}
.borderTable /deep/ .el-table--border th.gutter:last-of-type{
  border: none;
}
.borderTable /deep/ .el-table--border::after,.meiyu /deep/ .el-table--border{
  border: none;
  width: 0;
}
.meiyu /deep/ .el-table__footer-wrapper tbody td{
  color: #fff;
  background: #060a22;
}
.borderTable /deep/ .el-table__footer-wrapper tbody td{
  &:nth-of-type(2){
    background: #671529;
  }
  &:nth-of-type(3){
    background: #6c4617;
  }
  &:nth-of-type(4){
    background: #5a5d19;
  }
}
.meiyu /deep/ .el-table th {
  // text-align: center;
  color: #00deff;
  background: #060a22;
}
.meiyu /deep/ .el-table__body tr:hover > td {
  background: #072447;
}
.meiyu /deep/ .el-table::before {
  background: #060a22;
}
.meiyu /deep/ *::-webkit-scrollbar {
  width: 0.1rem;
  height: 0.25rem;
  background-color: #072351;
}
.meiyu /deep/ *::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #06214e;
}
.meiyu /deep/ *::-webkit-scrollbar-thumb {
  /*width: 0.1rem;
     */
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #0c3974;
}
.meiyu /deep/ .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}
.meiyu /deep/ .el-table__body-wrapper,
.meiyu /deep/ .is-scrolling-none,
.el-table {
  background: #060a22;
}
.flexDiv{
  display: flex;
  justify-content: center;
}
// .el-cascader-panel{
//   height: 200px;
//   width: 100%;
// }
</style>
